import { createAdminUsersService } from "./AdminUsersService";

export default createAdminUsersService("/admin/atendentes", "/admin/atendentes/perfis");
